import { useEffect, useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { IOptionsProps } from "../../../Components/Form/Select/select.component";
import { useToast } from "../../../Hooks/ToasContext";
import { ICategoryEntity } from "../../../Services/api/categories/categories.interface";
import { ICubageVariantAssociated } from "../../../Services/api/cubages-variants/cubages-variants.interface";
import { ICubageEntity } from "../../../Services/api/cubages/cubages.interface";


import { ListMangerStocksUseCase } from "../../../Usecase/Stocks/list-manager-stocks-usecase";
import { EStockNameEnum, IShowStocksByProductResponse, IStockEntity, IStockManagerListEntity } from "../../../Services/api/stocks/stocks.interface";
import { ShowProductUseCase } from "../../../Usecase/Products/show-product-usecase";
import { IProductEntity } from "../../../Services/api/products/products.interface";
import { ShowStocksByProductUseCase } from "../../../Usecase/Stocks/show-stocks-by-product-usecase";

import { DestroyStocksUseCase } from "../../../Usecase/Stocks/destroy-stocks-usecase";
import { normalizeStringData } from "../../../utils/chronos";

interface IUseCreateStocksProps {
  listMangerStocksUseCase: ListMangerStocksUseCase
  showProductUseCase: ShowProductUseCase
  showStocksByProductUseCase: ShowStocksByProductUseCase
  destroyStocksUseCase: DestroyStocksUseCase
}

export interface IStockProps {
    name: string;
    code: string;
    ncm: string;
    personalized: boolean
    createOnNuvemShop: boolean;

    // createOnOmie: boolean;
    createOnb2b: boolean;
    createOnb2c: boolean;
    price: string
    promotionalPrice: string
    description: string
    billingType:  'service' | 'sale'
    service: IOptionsProps
    [key: `cubage-${string}-variant-${string}`]: boolean;
    masterCode?: string
    artLink?: string
    maskCode?: string
    internalName?: string
}
  

  export const billingOptions = [
    
    {
      "value": "sale",
      "label": "Faturar como venda"
    },
    {
      "value": "service",
      "label": "Faturar como serviço"
    }
  ];

  const storeTypeOptions = [
    { label: 'Cadastrar na EMPO - B2B', value: 'createOnNSEmpo' },
    { label: 'Cadastrar na EMPO - B2C', value: 'createOnNSPapello' },
  ];

   const stockNameOptions = [
    { label: 'Empenho', value: EStockNameEnum.EMPENHO },
    { label: 'Produção', value: EStockNameEnum.PRODUCAO },
    { label: 'Acabado', value: EStockNameEnum.ACABADO },
  ];


export function useDetailsStocks({ listMangerStocksUseCase, showProductUseCase, showStocksByProductUseCase, destroyStocksUseCase }: IUseCreateStocksProps){
   
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState<IStockManagerListEntity>()
    const [product, setProduct] = useState<IProductEntity>()
    const [stocks, setStocks] = useState<IStockEntity[]>()
    const [startDate, setStartDate] = useState<any>()
    const [endDate, setEndDate] = useState<any>()
    const [stockName, setStockName] = useState<EStockNameEnum>(EStockNameEnum.EMPENHO)
    const [movimentationToDelete, setMovimentationToDelete] = useState<IStockEntity>()
    const params = useParams()
    
    const navigate = useNavigate()

    const { handleSubmit, register, control, formState, watch, setValue, unregister, getValues } = useForm<IStockProps>({
        // resolver: yupResolver(CreateBoxSchemaValidation),
        defaultValues: {
          // nsStore: data?.store as TStockStoreType | undefined,
          // name: data?.name || '',
          // description: data?.description || '',
          // price: data?.price || '',
          // code: data?.code || '',
          // ncm: data?.ncm || '',
          // promotionalPrice: data?.promotionalPrice || '',
          // personalized: data?.personalized || false,
          // billingType: (data?.billingType || 'sale') as 'service' | 'sale'
        }
      });

    const { errors } =  formState

    const { showToast } =  useToast()

    const handleAction: SubmitHandler<IStockProps> = async (values) => {
  
    try {
        setLoading(true)
        console.log("values: ", JSON.stringify(values))
        let normalizeValues : any = {...values}
     
        normalizeValues.nsStoreIds = [5061090]
        normalizeValues.createOnOmie = true

   

        if( normalizeValues.billingType === 'sale'){
          normalizeValues.stockServiceId = undefined
        }

        console.log("normalizeValues: ", normalizeValues)
     
        
        const formData = new FormData();

        Object.keys(normalizeValues).forEach((key) => {
          let value = normalizeValues[key];
          if ((key === 'price' || key === 'promotionalPrice') && value) {
            // Process the price value
            value = value
              .replace(/\s/g, '')          // Remove all whitespaces
              .replace(/R\$\s*/g, '')      // Remove 'R$' symbol and any trailing spaces
              .replace(/\./g, '')          // Remove thousands separator '.'
              .replace(',', '.');          // Replace decimal separator ',' with '.'
          }
          formData.append(key, value);
        });
        console.log("formData: ", formData)

        // Anexar as imagens ao FormData
        // const storeResult = params?.id ? await updateStockUseCase.handle({data: formData, id: params?.id}) : await createStockUseCase.handle(formData);

        // if (storeResult.isFailure) {
        
        // showToast(String(storeResult?.error?.error), 'error');
        // return;
        // }

        // showToast(params?.id ? 'Produto Editado' : 'Produto Cadastrado', 'success');
        
    
        // navigate('/stocks-list');
    } catch (error) {
      console.log("error: ", error)
        // toast({
        //   position: 'top-right',
        //   render: () => <ToastCustom type='fail' title='Erro' description={error.response?.data?.error ?? 'Erro ao logar. Por favor, tente novamente'} />,
        // });
    } finally {
        setLoading(false);
    }
    };

    
   
    const handleListManagerStocks = async (productId: string) => {
        
      try {
        setLoading(true)
        
        const listResult = await listMangerStocksUseCase.handle(productId);

        if (listResult.isFailure) {
     
          showToast(String(listResult?.error?.error), 'error');
          return;
        }

       const list = listResult.getValue()

       if(list){
          setData(list)
       }

  
    
      } catch (error) {
        console.log("error listCategories function: ", error)
      } finally {
        setLoading(false);
      }
    };

    const handleShowProduct = async (productId: string) => {
        
      try {
        setLoading(true)
        
        const listResult = await showProductUseCase.handle(productId);

        if (listResult.isFailure) {
     
          showToast(String(listResult?.error?.error), 'error');
          return;
        }

       const list = listResult.getValue()

       if(list){
          setProduct(list)
       }

  
    
      } catch (error) {
        console.log("error listCategories function: ", error)
      } finally {
        setLoading(false);
      }
    };

    const handleShowMovimentation = async () => {
        
      try {
        setLoading(true)
        if (!startDate || !endDate) {
          showToast('Por favor, selecione as datas de início e fim', 'error');
          return;
        }

        if (!stockName) {
          showToast('Por favor, selecione o tipo de estoque', 'error');
          return;
        }
        
        console.log("startDate: ", startDate)
        console.log("endDate: ", endDate)

        const formattedStartDate = normalizeStringData(startDate);
        const formattedEndDate = normalizeStringData(endDate);

        // Validar se a data final é menor que a data inicial
        if (new Date(formattedEndDate) < new Date(formattedStartDate)) {
          showToast('A data final não pode ser menor que a data inicial', 'error');
          return;
        }
        
 
        
        const listResult = await showStocksByProductUseCase.handle({
          productId: String(params.productId), 
          startDate: formattedStartDate, 
          endDate: formattedEndDate,
          stockName
        });

        if (listResult.isFailure) {
     
          showToast(String(listResult?.error?.error), 'error');
          return;
        }

       const list = listResult.getValue()

       setStocks(list?.stocks || [])

  
    
      } catch (error) {
        console.log("error handleShowMovimentation function: ", error)
      } finally {
        setLoading(false);
      }
    };

    const handleDestroyMovimentation  = async () => {
        
      try {
        setLoading(true)

        
        const listResult = await destroyStocksUseCase.handle(String(movimentationToDelete?.id));

        if (listResult.isFailure) {
     
          showToast(String(listResult?.error?.error), 'error');
          return;
        }

        showToast('Movimentação removida com sucesso', 'success');
        setMovimentationToDelete(undefined)
        handleShowMovimentation()
    
      } catch (error) {
        console.log("error handleShowMovimentation function: ", error)
      } finally {
        setLoading(false);
      }
    };

   
    useEffect(() => {
      if(params.productId){
        handleListManagerStocks(params.productId)
        handleShowProduct(params.productId)
      }
    },[params])

    console.log("stocks: ", stocks)


      

    return {
        loading,
        handleSubmit,
        handleAction,
        register,
        errors,
        control,
        data,
        storeTypeOptions,
        startDate,
        endDate,
        setStartDate,
        setEndDate,
        handleShowMovimentation,
        stocks,
        stockNameOptions,
        stockName,
        setStockName,
        product,
        setMovimentationToDelete,
        movimentationToDelete,
        handleDestroyMovimentation

        
        
    }
}